// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * cdr-shared-api
 * Shared API Gateway for all CDR endpoints
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface WorkflowStatusPendingApprovalsInner
 */
export interface WorkflowStatusPendingApprovalsInner {
    /**
     * 
     * @type {string}
     * @memberof WorkflowStatusPendingApprovalsInner
     */
    approval_id: string;
    /**
     * 
     * @type {string}
     * @memberof WorkflowStatusPendingApprovalsInner
     */
    approver_role: string;
    /**
     * 
     * @type {boolean}
     * @memberof WorkflowStatusPendingApprovalsInner
     */
    required: boolean;
    /**
     * 
     * @type {string}
     * @memberof WorkflowStatusPendingApprovalsInner
     */
    stage: string;
}

/**
 * Check if a given object implements the WorkflowStatusPendingApprovalsInner interface.
 */
export function instanceOfWorkflowStatusPendingApprovalsInner(value: object): value is WorkflowStatusPendingApprovalsInner {
    if (!('approval_id' in value) || value['approval_id'] === undefined) return false;
    if (!('approver_role' in value) || value['approver_role'] === undefined) return false;
    if (!('required' in value) || value['required'] === undefined) return false;
    if (!('stage' in value) || value['stage'] === undefined) return false;
    return true;
}

export function WorkflowStatusPendingApprovalsInnerFromJSON(json: any): WorkflowStatusPendingApprovalsInner {
    return WorkflowStatusPendingApprovalsInnerFromJSONTyped(json, false);
}

export function WorkflowStatusPendingApprovalsInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): WorkflowStatusPendingApprovalsInner {
    if (json == null) {
        return json;
    }
    return {
        
        'approval_id': json['approval_id'],
        'approver_role': json['approver_role'],
        'required': json['required'],
        'stage': json['stage'],
    };
}

export function WorkflowStatusPendingApprovalsInnerToJSON(json: any): WorkflowStatusPendingApprovalsInner {
    return WorkflowStatusPendingApprovalsInnerToJSONTyped(json, false);
}

export function WorkflowStatusPendingApprovalsInnerToJSONTyped(value?: WorkflowStatusPendingApprovalsInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'approval_id': value['approval_id'],
        'approver_role': value['approver_role'],
        'required': value['required'],
        'stage': value['stage'],
    };
}
